import { gql } from 'graphql-tag'

export const FRAGMENT_MESSAGE_OPERATOR_V1_MESSAGE = gql`
  fragment MessageOperatorV1Message on message {
    id
    type
    body_safe
  }
`
